import { render } from "./Image.vue?vue&type=template&id=2411702c&scoped=true&ts=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=2411702c&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2411702c"]])

export default __exports__